import { BarChart3, Zap } from "lucide-react";
import { catchAsync, checkDecimal, cn, formatIndianNumber, IS_SUCCESS_RESPONSE } from "src/helpers";

import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
} from "src/shadcn/components/ui";
import { CalculatorForm } from "../../../modules/MYTReportCopy/CalculationForm/CalculatorForm";
import { useMemo, useState } from "react";
import { API_RESP_INIT } from "../../../modules/MYTReportCopy/CalculationForm/modules";
import Comparison from "src/modules/MYTReportCopy/ComparisonDashboard/Comparison";
import ZonewiseRebates from "src/modules/MYTReportCopy/ComparisonDashboard/ZonewiseRebates";
import ImpactofChanges from "src/modules/MYTReportCopy/ComparisonDashboard/ImpactofChanges";
import SampleBillComparison from "src/modules/MYTReportCopy/ComparisonDashboard/SampleBillComparison";
import Projectsuggestion from "src/modules/MYTReportCopy/ComparisonDashboard/Projectsuggestion";
import { useMainContext } from "./MainContext";

type props = {
  apiData: any
}

export function ComparisonDashboard() {

  const [tabValue, setTabvalue] = useState("bill");

  const { apiRespData, formData } = useMainContext()

  const apiResponse = useMemo(() => apiRespData || API_RESP_INIT, [apiRespData])

  const COMPARISON_DATA = useMemo(() => {
    if (apiResponse && apiResponse?.["comparison Dashboard"]) {
      return Object.values(apiResponse?.["comparison Dashboard"]).map((data: any) => {
        return {
          parameter: data?.parameter || "-",
          beforeMYT: data?.beforeMYT || "-",
          afterMYT: data?.afterMYT || "-",
          change: data?.percentageChange || "-",
        };
      });
    }
    return [];
  }, [apiResponse]);

  const ZONE_WISE_REBATES_DATA = useMemo(() => {
    if (apiResponse && apiResponse?.["Zone-wise Rebates"]) {
      return Object.values(apiResponse?.["Zone-wise Rebates"]).map((data: any) => {
        return {
          parameter: data?.parameter || "-",
          beforeMYT: data?.beforeMYT || "-",
          afterMYT: data?.afterMYT || "-",
          change: data?.percentageChange || "-",
        };
      });
    }
    return [];
  }, [apiResponse]);

  const TOD_IMPACT_DATA = useMemo(() => {
    if (apiResponse && apiResponse?.["Impact of Changes in ToD tariff and banking provisions"]) {
      return Object.values(apiResponse?.["Impact of Changes in ToD tariff and banking provisions"]).map((data: any) => {
        return {
          zone: data?.name,
          beforeHours: data?.beforeMYT?.timeslot ? `${data?.beforeMYT?.hours}(${data?.beforeMYT?.timeslot})` : "-",
          beforeUnits: data?.beforeMYT?.units ? checkDecimal(data?.beforeMYT?.units, true) : "-",
          beforeRebate: data?.beforeMYT?.rebateRate || "-",
          beforeRebateAmount: data?.beforeMYT?.rebateAmount ? checkDecimal(data?.beforeMYT?.rebateAmount, true) : "-",
          afterHours: data?.afterMYT?.timeslot ? `${data?.afterMYT?.hours}(${data?.afterMYT?.timeslot})` : "-",
          afterUnits: data?.afterMYT?.units ? checkDecimal(data?.afterMYT?.units, true) : "-",
          afterRebate: data?.afterMYT?.rebateRate || "-",
          afterRebateAmount: data?.afterMYT?.rebateAmount ? checkDecimal(data?.afterMYT?.rebateAmount, true) : "-",
        };
      });
    }
    return [];
  }, [apiResponse]);

  const BILL_COMPARIZON_DATA = useMemo(() => {
    let units = 0;
    let tabledata: any[] = [];
    let total: any = {};
    let apiResp = apiResponse?.["Sample Bill Comparison"];
    if (apiResponse && apiResp && apiResponse?.["Sample Bill Comparison"]["components"]) {
      units = apiResp?.units;
      tabledata = Object.values(apiResponse?.["Sample Bill Comparison"]["components"]).map((data: any) => {
        console.log({ parameter: data?.parameter, oldTariff: data?.oldTariff, newTariff: data?.newTariff });

        let change = data?.change;

        if (change && (change != "0" || change != 0)) {
          console.log(change);
          const match = change?.match(/([+-])(\d+)/);
          const sign = match[1]; // "+" or "-"
          const number = match[2]; // "70000"
          change = `${sign}${formatIndianNumber(number, 0)}`;
        } else {
          change = data?.oldTariff && data?.newTariff ? "0" : "-";
        }
        return {
          component: data?.parameter,
          oldTariff: data?.oldTariff ? checkDecimal(data?.oldTariff?.toFixed(0), true) : "-",
          newTariff: data?.newTariff ? checkDecimal(data?.newTariff?.toFixed(0), true) : "-",
          change: change || null,
        };
      });
      total = apiResp?.total;
      if (total?.change && total?.change != "0") {
        const match = total?.change?.match(/([+-])(\d+)/);
        const sign = match[1]; // "+" or "-"
        const number = match[2]; // "70000"
        total = {
          ...total,
          change: `${sign}${formatIndianNumber(number, 0)}`,
        };
      }
    }

    return { units, tabledata, total };
  }, [apiResponse]);

  return (
    <div className="">
      <div className=" grid sm:grid-cols-1 md:grid-cols-5 gap-4">
        <Card className="order-2 md:order-1 md:col-span-5">
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <BarChart3 className="h-5 w-5 text-blue-500" />
              Comparison Dashboard
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-6">
            <Comparison COMPARISON_DATA={COMPARISON_DATA} />
            <ZonewiseRebates ZONE_WISE_REBATES_DATA={ZONE_WISE_REBATES_DATA} />
          </CardContent>
        </Card>
        {/* <div className=" order-1 md:order-2 md:col-span-2 ">
          <CalculatorForm getData={(e: any) => setapiResponse(e)} formikData={(e: any) => setFormData(e)} />
        </div> */}
      </div>

      <ImpactofChanges TOD_IMPACT_DATA={TOD_IMPACT_DATA} />

      <Card className="w-full flex  flex-col gap-6 ">
        <Tabs defaultValue={tabValue} className="w-full" onValueChange={(e) => setTabvalue(e)}>
          <div className="w-full flex justify-between items-center ">
            <CardHeader>
              {tabValue === "bill" ? (
                <CardTitle className="flex items-center gap-2">
                  <Zap className="h-5 w-5 text-orange-500" />
                  Sample Bill Comparison{" "}
                  <>
                    {BILL_COMPARIZON_DATA?.units
                      ? `(Based on ${checkDecimal(BILL_COMPARIZON_DATA?.units.toString(), true)} Units)`
                      : ""}
                  </>
                </CardTitle>
              ) : (
                <CardTitle className="flex items-center gap-2">
                  <Zap className="h-5 w-5 text-orange-500" />
                  Project suggestion{" "}
                </CardTitle>
              )}
            </CardHeader>
            <TabsList>
              <TabsTrigger value="bill">Sample Bill Comparison</TabsTrigger>
              <TabsTrigger disabled={!BILL_COMPARIZON_DATA?.total?.change} value="suggestion">
                Project suggestion
              </TabsTrigger>
            </TabsList>
          </div>

          <TabsContent value="bill" className="w-full">
            <CardContent>
              <SampleBillComparison BILL_COMPARIZON_DATA={BILL_COMPARIZON_DATA} />
            </CardContent>
          </TabsContent>

          <TabsContent value="suggestion">
            <CardContent>
              <Projectsuggestion formData={formData} />
            </CardContent>
          </TabsContent>
        </Tabs>
      </Card>

    </div>
  );
}
